import axios from 'axios';
import Token from 'types/models/Token';

export default class AIApiService {
  public static instance: AIApiService;

  public static baseUrl = process.env.REACT_APP_AI_API_URL;

  public static get Instance() {
    // eslint-disable-next-line no-return-assign
    return AIApiService.instance || (AIApiService.instance = new AIApiService());
  }

  public static async SendhQuery(data: any) {
    try {
      const localStorageToken: string | null = localStorage.getItem('cognito-token');
      let cognitoToken: Token = {
        id_token: '',
      };
      if (localStorageToken) {
        cognitoToken = JSON.parse(localStorageToken);
      }

      const res = await axios.post(`${this.baseUrl}`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${cognitoToken.id_token}`,
        },
      });
      const parsedData = JSON.parse(res.data);
      return parsedData;
    } catch (error: unknown) {
      return null;
    }
  }
}
